import {
    getRequest,
    deleteRequest,
    objectToFormData,
    postRequestFormData,
    patchRequestFormData
} from "./utilities/http";
import {toQueryString} from "../utilities/helpers";
import {IFetchFloorPlanBaseDto} from "../common/interfaces/floor-plan-base";
import {FLOOR_PLAN_BASE} from "./utilities/api.urls";

export const fetchFloorPlansBase = async (data: IFetchFloorPlanBaseDto) => {
    return await getRequest(FLOOR_PLAN_BASE + '?' + toQueryString(data));
}

export const fetchFloorPlanBase = async (id: number) => {
    return await getRequest(FLOOR_PLAN_BASE + `/${id}`);
}

export const deleteFloorPlanBase = async (id: number) => {
    return await deleteRequest(FLOOR_PLAN_BASE + `/${id}`)
}

export const saveNewFloorPlanBase = async (base: any) => {
    const file = base.file;
    // @ts-ignore
    delete base.file;

    const formData = objectToFormData(base);
    if (file) {
        formData.append('baseFile', file, file.name);
    }

    return await postRequestFormData(FLOOR_PLAN_BASE, formData);
}

export const updateFloorPlanBase = async (id: number, base: any) => {
    const file = base.file;
    // @ts-ignore
    delete base.file;

    const formData = objectToFormData(base);
    if (file) {
        formData.append('baseFile', file, file.name);
    }
    return await patchRequestFormData(FLOOR_PLAN_BASE + `/${id}`, formData)
}
